import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const globalBasketsData = [
    [
        {
            name: "Apple Inc",
            symbol: "NASDAQ:AAPL",
            image: "apple",
        },
        {
            name: "Microsoft Corp",
            symbol: "NASDAQ:MSFT",
            image: "microsoft",
        },
        {
            name: "Coca-Cola",
            symbol: "NYSE:KO",
            image: "cocacola",
        },
        {
            name: "Alphabet Inc",
            symbol: "NASDAQ:GOOGL",
            image: "alphabet",
        },
        {
            name: "Nike Inc",
            symbol: "NYSE:NKE",
            image: "nike",
        },
        {
            name: "McDonald's Corp",
            symbol: "NYSE:MCD",
            image: "mcd",
        },
        {
            name: "Procter & Gamble",
            symbol: "NYSE:PG",
            image: "pg",
        },
        {
            name: "Exxon Mobil Corp",
            symbol: "NYSE:XOM",
            image: "exxon",
        },
        {
            name: "Merck & Co",
            symbol: "NYSE:MRK",
            image: "merck",
        },
        {
            name: "AMD",
            symbol: "NASDAQ:AMD",
            image: "amd",
        },
    ],
    [
        {
            name: "Pfizer Inc",
            symbol: "NYSE:PFE",
            image: "pfizer",
        },
        {
            name: "Rio Tento",
            symbol: "NYSE:RIO",
            image: "rio",
        },
        {
            name: "Shell PLC",
            symbol: "NYSE:SHEL",
            image: "shell",
        },
        {
            name: "Chevron Corp",
            symbol: "NYSE:CVX",
            image: "chevron",
        },
        {
            name: "Unilever PLC",
            symbol: "NYSE:UL",
            image: "unilever",
        },
        {
            name: "Newmont Corp",
            symbol: "NYSE:NEM",
            image: "newmont",
        },
    ],
    [
        {
            name: "Alphabet Inc",
            symbol: "NASDAQ:GOOGL",
            image: "alphabet",
        },
        {
            name: "Microsoft Corp",
            symbol: "NASDAQ:MSFT",
            image: "microsoft",
        },
        {
            name: "Apple Inc",
            symbol: "NASDAQ:AAPL",
            image: "apple",
        },
        {
            name: "AMD",
            symbol: "NASDAQ:AMD",
            image: "amd",
        },
        {
            name: "Tesla Inc",
            symbol: "NASDAQ:TSLA",
            image: "tesla",
        },
        {
            name: "TSMC",
            symbol: "NYSE:TSM",
            image: "tsmc",
        },
    ],
    [
        {
            name: "SPSK US Equity",
            symbol: "AMEX:SPSK",
            image: "",
        },
        {
            name: "ISDW LN Equity",
            symbol: "LSE:ISDW",
            image: "",
        },
        {
            name: "ISDE LN Equity",
            symbol: "LSE:ISDE",
            image: "",
        },
        {
            name: "PHAU LN Equity",
            symbol: "LSE:PHAU",
            image: "",
        },
    ],
];

export const indianBasketsData = [
    [
        {
            name: "DIVI'S LABORATORIES LIMITED",
            symbol: "XNSE:DIVISLAB",
            image: "divis",
        },
        {
            name: "DR.REDDY'S LABORATORIES LTD",
            symbol: "XNSE:DRREDDY",
            image: "drreddy",
        },
        {
            name: "CIPLA LIMITED",
            symbol: "XNSE:CIPLA",
            image: "cipla",
        },
        {
            name: "MAX HEALTHCARE INSTITUTE LIMITED",
            symbol: "XNSE:MAXHEALTH",
            image: "max",
        },
        {
            name: "SYNGENE INTERNATIONAL LIMITED",
            symbol: "XNSE:SYNGENE",
            image: "syngene",
        },
        {
            name: "GRANULES INDIA LIMITED",
            symbol: "XNSE:GRANULES",
            image: "granules",
        },
    ],
    [
        {
            name: "INFOSYS LIMITED",
            symbol: "XNSE:INFY",
            image: "infosys",
        },
        {
            name: "ABB India Limited",
            symbol: "XNSE:ABB",
            image: "abb",
        },
        {
            name: "HINDUSTAN UNILEVER LIMITED",
            symbol: "XNSE:HINDUNILVR",
            image: "unilever",
        },
        {
            name: "ASIAN PAINTS LIMITED",
            symbol: "XNSE:ASIANPAINT",
            image: "asian",
        },
        {
            name: "PI INDUSTRIES LIMITED",
            symbol: "XNSE:PIIND",
            image: "pi",
        },
        {
            name: "BRITANNIA INDUSTRIES LTD",
            symbol: "XNSE:BRITANNIA",
            image: "britannia",
        },
        {
            name: "EICHER MOTORS LIMITED",
            symbol: "XNSE:EICHERMOT",
            image: "eicher",
        },
    ],
    [
        {
            name: "HINDUSTAN UNILEVER LIMITED",
            symbol: "XNSE:HINDUNILVR",
            image: "unilever",
        },
        {
            name: "MARICO LIMITED",
            symbol: "XNSE:MARICO",
            image: "marico",
        },
        {
            name: "CIPLA LIMITED",
            symbol: "XNSE:CIPLA",
            image: "cipla",
        },
        {
            name: "DABUR INDIA LIMITED",
            symbol: "XNSE:DABUR",
            image: "dabur",
        },
        {
            name: "COLGATE-PALMOLIVE (INDIA) LIMITED",
            symbol: "XNSE:COLPAL",
            image: "cp",
        },
        {
            name: "GUJARAT GAS LIMITED",
            symbol: "XNSE:GUJGASLTD",
            image: "gujgas",
        },
        {
            name: "BRITANNIA INDUSTRIES LTD",
            symbol: "XNSE:BRITANNIA",
            image: "britannia",
        },
        {
            name: "AVENUE SUPERMARTS LIMITED",
            symbol: "XNSE:DMART",
            image: "dmart",
        },
    ],
    [
        {
            name: "RELIANCE INDUSTRIES LIMITED",
            symbol: "XNSE:RELIANCE",
            image: "reliance",
        },
        {
            name: "ASIAN PAINTS LIMITED",
            symbol: "XNSE:ASIANPAINT",
            image: "asian",
        },
        {
            name: "PETRONET LNG LIMITED",
            symbol: "XNSE:PETRONET",
            image: "petronet",
        },
        {
            name: "KAJARIA CERAMICS LIMITED",
            symbol: "XNSE:KAJARIACER",
            image: "kajaria",
        },
        {
            name: "CARBORUNDUM UNIVERSAL LIMITED",
            symbol: "XNSE:CARBORUNIV",
            image: "cumi",
        },
        {
            name: "JAMNA AUTO INDUSTRIES LIMITED",
            symbol: "XNSE:JAMNAAUTO",
            image: "jamna",
        },
        {
            name: "APL Apollo Tubes Limited",
            symbol: "XNSE:APLAPOLLO",
            image: "apl",
        },
        {
            name: "THE PHOENIX MILLS LIMITED",
            symbol: "XNSE:PHOENIXLTD",
            image: "phoenix",
        },
        {
            name: "CRISIL Limited",
            symbol: "XNSE:CRISIL",
            image: "crisil",
        },
    ],
];

